/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_PrivacyInputs */

const en_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const zh_hans1_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const pt_br2_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Privacidade`)
};

const es_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const fr_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const de_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklärung`)
};

const ru_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

const it_footer_privacy = /** @type {(inputs: Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla privacy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_PrivacyInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_privacy = /** @type {((inputs?: Footer_PrivacyInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_PrivacyInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_privacy(inputs)
	if (locale === "pt-BR") return pt_br2_footer_privacy(inputs)
	if (locale === "es") return es_footer_privacy(inputs)
	if (locale === "fr") return fr_footer_privacy(inputs)
	if (locale === "de") return de_footer_privacy(inputs)
	if (locale === "ru") return ru_footer_privacy(inputs)
	if (locale === "it") return it_footer_privacy(inputs)
	return en_footer_privacy(inputs)
});